import { createContext, useContext, useState, useEffect, useMemo } from "react";

const UtilityContext = createContext({
  activeSection: "Dashboard",
  currentModuleIndex: 0,
  setCurrentModuleIndex: () => {},
  setActiveSection: () => {},
  selectedCourseId: null,
  setSelectedCourseId: () => {},
  activeCourseTab: "Home",
  setActiveCourseTab: () => {},
});

export const useUtilityContext = () => {
  const context = useContext(UtilityContext);
  if (!context) {
    throw new Error("useUtility must be used within a UtilityProvider");
  }
  return context;
};

const UtilityProvider = ({ children }) => {
  // Helper to get user role for keying
  const getRole = () => {
    const user = localStorage.getItem("user");
    return user ? JSON.parse(user).role : "student";
  };

  const [activeSection, setActiveSection] = useState(() => {
    const role = getRole();
    return localStorage.getItem(`${role}_activeSection`) || "Dashboard";
  });
  const [currentModuleIndex, setCurrentModuleIndex] = useState(0);
  const [selectedCourseId, setSelectedCourseId] = useState(() => {
    return localStorage.getItem(`${getRole()}_selectedCourseId`) || null;
  });
  const [activeCourseTab, setActiveCourseTab] = useState(() => {
    return localStorage.getItem(`${getRole()}_activeCourseTab`) || "Home";
  });

  useEffect(() => {
    const role = getRole();
    localStorage.setItem(`${role}_activeSection`, activeSection);
  }, [activeSection]);

  useEffect(() => {
    const role = getRole();
    if (selectedCourseId) {
      localStorage.setItem(`${role}_selectedCourseId`, selectedCourseId);
    } else {
      localStorage.removeItem(`${role}_selectedCourseId`);
    }
  }, [selectedCourseId]);

  useEffect(() => {
    const role = getRole();
    localStorage.setItem(`${role}_activeCourseTab`, activeCourseTab);
  }, [activeCourseTab]);

  const value = useMemo(
    () => ({
      activeSection,
      setActiveSection,
      currentModuleIndex,
      setCurrentModuleIndex,
      selectedCourseId,
      setSelectedCourseId,
      activeCourseTab,
      setActiveCourseTab,
    }),
    [activeSection, currentModuleIndex, selectedCourseId, activeCourseTab]
  );

  return (
    <UtilityContext.Provider value={value}>
      {children}
    </UtilityContext.Provider>
  );
};

export default UtilityProvider;
